module.exports = __webpack_public_path__ + "img/user-profile.2a8ede5b.png";